/* eslint-disable react/prop-types */
import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const AlertDialogV2 = ({ isLoading, isOpen, onClose, onAction, title }) => {
  const {t} = useTranslation()
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}{' '}?
          </AlertDialogHeader>

          <AlertDialogBody>{t('deletePermanent')}</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} size={'sm'}>{t('cancel')}</Button>
            <Button
              isLoading={isLoading}
              colorScheme="red"
              onClick={onAction}
              ml={3}
              size='sm'
            >
              {t('confirm')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default AlertDialogV2;
